import React from "react";
import { Box, Modal, Typography } from "components";
import { AppColor } from "theme/app-color";

interface DependencyLoopDetectedModalProps {
  transactionPlanName: string;
  t: (key: string, options?: any) => string;
}

export const showDependencyLoopDetectedModal = ({
  transactionPlanName,
  t,
}: DependencyLoopDetectedModalProps) => {
  Modal.alert({
    title: t("client.error.dependencyLoopDetected.errorTitle"),
    children: (
      <Box display="flex" flexDirection="column">
        <Box>
          <Typography variant="Body/16">
            {t("client.error.dependencyLoopDetected.loopDetected1")}{" "}
            <Typography variant="Header/16" component="span">
              {transactionPlanName}
            </Typography>{" "}
            <Typography variant="Body/16" component="span">
              {t("client.error.dependencyLoopDetected.loopDetected2")}
            </Typography>
          </Typography>
        </Box>
        <Typography
          variant="Body/16"
          color={AppColor["Other/Danger"]}
          style={{ marginTop: "16px" }}
        >
          {"*"}
          {t("client.error.dependencyLoopDetected.errorDescription")}
        </Typography>
      </Box>
    ),
    okButtonLabel: t("client.error.dependencyLoopDetected.close"),
    onOk: async ({ close }: any) => {
      close();
    },
    disableBackdropClick: true,
  });
};
